import { StripeMeshGradient } from '@/components/StripeMeshGradient';

/**
 * Shared animated gradient backdrop for the "dumb" V2 pages
 * (V2Auth, V2Onboarding, V2Subscribe). Mirrors UserFlowLayout.
 *
 * Mount as a sibling at the top of the page return. Sits behind all
 * page content (z-index 0) and behind any explicit z-10+ overlays.
 */
const STATIC_GRADIENT =
  'linear-gradient(135deg, #1a0a10 0%, #2a0a3a 50%, #0a0a0a 100%)';

export function V2DumbBackground() {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 z-0 pointer-events-none"
      style={{ background: STATIC_GRADIENT }}
    >
      <StripeMeshGradient
        color1="#0a0408"
        color2="#6B2D4A"
        color3="#3A0E6E"
        color4="#0a0408"
      />
    </div>
  );
}
